var _path, _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJapan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_105)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_105",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 24,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H25V19H1V1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_105)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.5 1H26.5V19H-0.5V1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.002 15.596C16.0921 15.596 18.5971 13.0909 18.5971 10.0008C18.5971 6.9107 16.0921 4.40567 13.002 4.40567C9.91189 4.40567 7.40686 6.9107 7.40686 10.0008C7.40686 13.0909 9.91189 15.596 13.002 15.596Z",
    fill: "#D30000"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8125,
    y: 0.8125,
    width: 24.375,
    height: 18.375,
    stroke: "#E8E8E8",
    strokeWidth: 0.375
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_105"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJapan);
export default __webpack_public_path__ + "static/media/japan.fdf19c964c7dd87b8afaf95615f7f798.svg";
export { ForwardRef as ReactComponent };